import { YoutubeLinkRepository } from '../../domain/repositories/youtube-link.repository.js';
import { YoutubeLinkEntity, YoutubeLinkProps } from '../../domain/entities/youtube-link.entity.js';

export type UpdateYoutubeLinkInput = Partial<Omit<YoutubeLinkProps, 'id' | 'createdAt' | 'updatedAt' | 'videoId' | 'thumbnailUrl'>>;

export class UpdateYoutubeLinkUseCase {
  constructor(private readonly repository: YoutubeLinkRepository) {}

  public async execute(id: string, input: UpdateYoutubeLinkInput): Promise<YoutubeLinkEntity> {
    return this.repository.update(id, input);
  }
}
